import {invalidateOnSuccess, omneticApi} from '@dms/api/base';

import {
  DeleteVehicleLocalizedContentArg,
  GetVehicleLocalizedContentArg,
  SetVehicleLocalizedContentArg,
  VehicleLocalizedContentListResponse,
} from './types';

export const vehicleLocalizedContentApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getVehicleLocalizedContent: build.query<
      VehicleLocalizedContentListResponse,
      GetVehicleLocalizedContentArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/localized-content`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'VehicleLocalizedContent', id: queryArg.vehicleId},
      ],
    }),
    setVehicleLocalizedContent: build.mutation<void, SetVehicleLocalizedContentArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/localized-content/${queryArg.language}`,
        method: 'PUT',
        body: queryArg.body,
      }),
      invalidatesTags: invalidateOnSuccess((_result, queryArg: SetVehicleLocalizedContentArg) => [
        {type: 'VehicleLocalizedContent', id: queryArg.vehicleId},
      ]),
    }),
    deleteVehicleLocalizedContent: build.mutation<void, DeleteVehicleLocalizedContentArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/localized-content/${queryArg.language}`,
        method: 'DELETE',
      }),
      invalidatesTags: invalidateOnSuccess(
        (_result, queryArg: DeleteVehicleLocalizedContentArg) => [
          {type: 'VehicleLocalizedContent', id: queryArg.vehicleId},
        ]
      ),
    }),
  }),
});

export const {
  useGetVehicleLocalizedContentQuery,
  useSetVehicleLocalizedContentMutation,
  useDeleteVehicleLocalizedContentMutation,
} = vehicleLocalizedContentApi;
